import React, { useEffect, useState, useCallback } from 'react';
import { debounce } from 'lodash';
import moment from 'moment';
import { Input, Button, Popconfirm, message, Space } from 'antd';
import { TableLayout, RangeDateFilter } from '~components';
import { OilPricesForm } from './oil-price-form';
import DriverFields from './fields-data';
import ApiServices from '~services';
import Utils from '~commons/utils';
import { TableTitle } from '~commons/styles';

const DEFAULT_QUERIES = {
  PageSize: 10,
  PageNumber: 1,
  DateFrom: moment().startOf('month').format('YYYY-MM-DD'),
  DateTo: moment().endOf('date').format('YYYY-MM-DD'),
};

const ManagementSalary = () => {
  const defaultTabPanels = [
    {
      title: 'Detail',
      content: 'detail content',
    },
  ];
  const [loading, setLoading] = useState(false);
  const [isLoadingTab, setIsLoadingTab] = useState(false);
  const [selected, setSelected] = useState('');
  const [managementCosts, setManagementCosts] = useState([]);
  const [tabPanels, setTabPanels] = useState(defaultTabPanels);
  const [titleTab, setTitleTab] = useState('');
  const [fields, setFields] = useState({});
  console.log(fields);
  const [filter, setFilter] = useState(DEFAULT_QUERIES);

  const getData = async (query = DEFAULT_QUERIES) => {
    setLoading(true);
    const newQuery = { ...query };
    return ApiServices.getManagementSalaries(newQuery)
      .then((res) => {
        if (res?.data) {
          setManagementCosts(res?.data);
        }
      })
      .catch((err) => {
        console.error('Get Vats Paging Error', err);
      })
      .finally(() => setLoading(false));
  };

  const onColumnSearch = (event) => {
    setFilter((prev) => {
      const Columns = { ...prev.Columns };
      const value = event.target.value;
      const name = event.target.name;
      if (!value) {
        delete Columns[name];
        return { ...prev, Columns, PageNumber: 1 };
      }
      Columns[name] = value;

      return { ...prev, Columns, PageNumber: 1 };
    });
  };

  const timeoutGetData = useCallback(
    debounce((newFilter) => {
      getData(newFilter);
    }, 500),
    []
  );
  useEffect(() => {
    timeoutGetData(filter);
  }, [filter]);

  const setFieldsForm = async (value) => {
    const driverFields = await DriverFields(value);
    await setFields(driverFields);
    return driverFields;
  };
  const reload = async () => {
    setSelected(null);
    await getData(filter);
  };

  const getUpdatedOilPriceForm = async (value, isNew = false, dataSelect, id = null) => {
    const driverForm = await (
      <OilPricesForm
        fields={value}
        setLoading={setIsLoadingTab}
        isNew={isNew}
        id={id}
        dataSelect={dataSelect}
        reload={reload}
        onChange={setFields}
      />
    );
    return setTabPanels([
      {
        title: 'Thông Tin Chi Tiết',
        content: driverForm,
      },
    ]);
  };

  const onRowSelected = async (value) => {
    const _value = {
      ...value,
      inputDate: Utils.convertToDate(value?.inputDate),
    };

    await setIsLoadingTab(true);
    await setTitleTab('Cập nhật');
    await setFieldsForm(_value)
      .then((res) => {
        return getUpdatedOilPriceForm(res, false, value, _value.id);
      })
      .then(() => setSelected(_value));
    setIsLoadingTab(false);
  };
  const deleteSupplierBills = async (record) => {
    setLoading(true);
    return ApiServices.deleteManagementSalary(record?.id)
      .then((res) => {
        if (res?.data?.data) {
          message.success('Xoá Lương quản lí thành công');
          return reload();
        } else {
          message.error('Xoá Lương quản lí thất baị, vui lòng kiểm tra lại thông tin');
        }
      })
      .catch((err) => {
        console.log('Delete oil prices failed: ', err);
        message.error('Xoá Lương quản lí thất baị, vui lòng kiểm tra lại thông tin');
      })
      .finally(() => setLoading(false));
  };

  const columns = [
    {
      title: (
        <TableTitle>
          Tên
          <Input name='name' onChange={onColumnSearch} placeholder='Search' />
        </TableTitle>
      ),
      dataIndex: 'name',
      align: 'center',
      render: (value, record) => (
        <a onClick={() => onRowSelected(record)}>{value || 'underFine'}</a>
      ),
    },
    {
      title: (
        <TableTitle>
          Giá
          <Input name='price' onChange={onColumnSearch} placeholder='Search' />
        </TableTitle>
      ),
      dataIndex: 'price',
      align: 'center',
    },
    {
      title: (
        <TableTitle>
          Phòng ban
          <Input name='departmentName' onChange={onColumnSearch} placeholder='Search' />
        </TableTitle>
      ),
      dataIndex: 'departmentName',
      align: 'center',
    },
    {
      title: <TableTitle>Ngày hiệu lực</TableTitle>,
      dataIndex: 'effectiveDate',
      align: 'center',
      width: 150,
      render: (val) => Utils.formatDate(val),
    },
    {
      title: (
        <TableTitle>
          Ghi chú
          <Input name='note' onChange={onColumnSearch} placeholder='Search' />
        </TableTitle>
      ),
      dataIndex: 'note',
      align: 'center',
    },
    {
      title: 'Action',
      fixed: 'right',
      align: 'center',
      width: 90,
      render: (record) => (
        <Popconfirm
          onConfirm={() => deleteSupplierBills(record)}
          title='Xoá Lương quản lí này?'
          okText='Yes'
          cancelText='No'
        >
          <a href='#' style={{ color: 'red' }}>
            Xoá
          </a>
        </Popconfirm>
      ),
    },
  ];

  const createDriver = async () => {
    await setTitleTab('Thêm mới');
    await setFieldsForm({})
      .then((res) => getUpdatedOilPriceForm(res, true))
      .then(() => setSelected({ isNew: true }));
    await setIsLoadingTab(false);
  };

  const headerContent = (
    <Space>
      <RangeDateFilter query={filter} onChange={setFilter} />
      <Button type='primary' onClick={createDriver}>
        Thêm Mới
      </Button>
    </Space>
  );

  const pagination = {
    total: managementCosts?.totalRecords || 0,
    showSizeChanger: true,
    pageSize: filter.PageSize,
    current: filter.PageNumber,
    onChange: (PageNumber, PageSize) =>
      setFilter((prev) => ({
        ...prev,
        PageNumber,
        PageSize,
      })),
  };

  return (
    <TableLayout
      rowKey='id'
      columns={columns}
      data={managementCosts?.data || []}
      loading={loading}
      selected={selected}
      closeDrawer={() => setSelected(null)}
      isLoadingTab={isLoadingTab}
      headerContent={headerContent}
      titleTab={titleTab}
      tabPanels={tabPanels}
      pagination={pagination}
      isDisplayCheckbox={false}
    />
  );
};

export { ManagementSalary };
